import { createApp,ref } from 'vue'
import App from './App.vue'
import './assets/index.css'
import helper from "@/utils/helper";
import store from './store'
import router from './router'
import i18n from './i18n'
const app = createApp(App).use(i18n)
app.config.globalProperties.$loading = ref(false)
app
.use(router)
.use(store)
.use(helper)
.mount('#app')
export default app
